import Sprite from "app/components/sprite";
import { useTagDispatch } from "app/context/tags";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useCallback } from "react";

const activeStyle = "bg-primary";
const inactiveStyle = "bg-white";
const activeStyleText = `
  bg-gradient-to-r from-yellow-dark
  via-green to-cyan text-transparent
  bg-clip-text
`;
const inactiveStyleText = "text-primary";

export const Tag = ({ text = "Tag", active = false, logo }) => {
  const { t: trans } = useTranslation();
  const dispatch = useTagDispatch();

  const setTag = useCallback(() => {
    dispatch(text);
  }, [text]);

  return (
    <button
      className={`
        ${active ? activeStyle : inactiveStyle}
        mx-2 min-w-[85px] items-center rounded-full
        px-5 py-2 text-sm font-bold
        shadow-[0_0_15px_0.05px_rgba(0,0,0,0.03)]
      `}
      onClick={() => setTag()}
    >
      <div className="flex items-center justify-center">
        <Sprite
          name={logo}
          className={`
            ${active ? "fill-yellow-dark" : "fill-current"}
            ${logo ? "w-[25px] ltr:mr-2 rtl:ml-2" : "mr-0 w-[0px]"}
            h-[25px]
          `}
        />
        <p
          className={`
          ${active ? activeStyleText : inactiveStyleText}
        `}
        >
          {trans(text)}
        </p>
      </div>
    </button>
  );
};

Tag.propTypes = {
  text: PropTypes.string,
  logo: PropTypes.string,
  active: PropTypes.bool,
};
